import { Col, Row } from 'reactstrap';
import { Icon } from '@octano/global-ui';
import useTexts from '../../../hooks/useTexts';
import {
  LessonReservationDetail,
  EventReservationDetail,
} from '../../../types';

interface FutureReservationsContentProps {
  lessons: LessonReservationDetail[];
  events: EventReservationDetail[];
  isDisabling?: boolean;
}

export function FutureReservationsContent({
  lessons,
  events,
  isDisabling,
}: FutureReservationsContentProps) {
  const texts = useTexts();

  const formatDate = (dateString: string) => {
    const [year, month, day] = dateString.split('-');
    return `${day}/${month}/${year}`;
  };

  const formatTime = (timeString: string) => {
    return timeString.slice(0, 5);
  };

  return (
    <>
      <Row className="justify-content-center mt-4">
        <Col xs="auto">
          <Icon name="warning" size="60" />
        </Col>
      </Row>
      <p className="text-dark fs-22 mt-3 mb-4 text-center">
        {isDisabling ? texts.disable.cannotDisable : texts.delete.cannotDelete}
      </p>
      <div className="text-dark fs-16 mt-3 mb-4 text-center">
        {texts.delete.cannotSubtitle}
      </div>

      <div
        className="border rounded p-3 mb-3 mt-4 mx-auto"
        style={{ maxWidth: '400px', maxHeight: '500px', overflowY: 'auto' }}
      >
        {lessons.length > 0 && (
          <ul className="mb-2">
            {lessons.map((lesson, index) => (
              <li key={index} className="mb-2">
                <div className="fs-14">
                  {texts.reservationDetails.subject}:{' '}
                  <strong>{lesson.subjectName}</strong>
                </div>
                <div className="fs-14">
                  {texts.reservationDetails.section}:{' '}
                  <strong>{lesson.sectionCode}</strong>
                </div>
                <div className="fs-14">
                  {texts.reservationDetails.startDate}:{' '}
                  <strong>{formatDate(lesson.startDate)}</strong>
                </div>
                <div className="fs-14">
                  {texts.reservationDetails.endDate}:{' '}
                  <strong>{formatDate(lesson.endDate)}</strong>
                </div>
                <div className="fs-14">
                  {texts.reservationDetails.schedule}:{' '}
                  <strong>
                    {formatTime(lesson.schedule.startModule.startTime)} -{' '}
                    {formatTime(lesson.schedule.endModule.endTime)}
                  </strong>
                </div>
              </li>
            ))}
          </ul>
        )}

        {events.length > 0 && (
          <ul className="mb-4">
            {events.map((event, index) => (
              <li key={index}>
                <div className="fs-14">
                  {texts.reservationDetails.event}:{' '}
                  <strong>{event.eventName}</strong>
                </div>
                <div className="fs-14">
                  {texts.reservationDetails.startDate}:{' '}
                  <strong>{formatDate(event.date)}</strong>
                </div>
                <div className="fs-14">
                  {texts.reservationDetails.schedule}:{' '}
                  <strong>
                    {formatTime(event.schedule.startModule.startTime)} -{' '}
                    {formatTime(event.schedule.endModule.endTime)}
                  </strong>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </>
  );
}
